import { AnyAction } from 'redux';

import {
    HEADER_BANNER_DETAIL_CREATE,
    HEADER_BANNER_DETAIL_ERROR,
    HEADER_BANNER_DETAIL_FETCH,
    HEADER_BANNER_DETAIL_RECEIVE,
    HEADER_BANNER_DETAIL_RESET,
    HEADER_BANNER_DETAIL_UPDATE,
} from './header-banner-detail-actions';
import { HeaderBanner } from '../models/header-banner';

export interface HeaderBannerDetailReducerState {
    headerBanner: HeaderBanner | null;
    requesting: boolean;
}

const initialHeaderBannerListReducerState: HeaderBannerDetailReducerState = {
    headerBanner: null,
    requesting: false,
};

export const headerBannerDetailReducer = (
    state: HeaderBannerDetailReducerState = initialHeaderBannerListReducerState,
    action: AnyAction
): HeaderBannerDetailReducerState => {
    switch (action.type) {
        case HEADER_BANNER_DETAIL_RESET: {
            return {
                ...state,
                headerBanner: null,
            };
        }

        case HEADER_BANNER_DETAIL_FETCH:
        case HEADER_BANNER_DETAIL_CREATE:
        case HEADER_BANNER_DETAIL_UPDATE: {
            return {
                ...state,
                requesting: true,
            };
        }

        case HEADER_BANNER_DETAIL_RECEIVE: {
            return {
                ...state,
                requesting: false,
                headerBanner: action['headerBanner'],
            };
        }

        case HEADER_BANNER_DETAIL_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
